import { AuthProvider, useAuth } from "./AuthContext.tsx";
import PlayerCards from "./components/PlayerCards.tsx";
import LoginDialog from "./components/LoginDialog.tsx";
import GuestView from "./components/GuestView.tsx";
import { SeasonProvider } from "./SeasonContext.tsx";

function AppContent() {
  const { auth, isLoading } = useAuth();

  if (isLoading) return null;

  if (auth.role === "GUEST") return <GuestView />;

  return (
    <>
      <LoginDialog open={auth.role === null} />
      {auth.role !== null && (
        <SeasonProvider>
          <PlayerCards />
        </SeasonProvider>
      )}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
